import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import emptyBoxImg from "../../assets/images/empty-box.png";

const EmptyBox: React.FC<{ title?: string }> = ({ title }) => {
  const { t } = useTranslation();

  // Using plain div instead of MUI Box to avoid TypeScript union type complexity
  // This is necessary after adding @react-three packages which increase type complexity
  const boxStyle: React.CSSProperties = {
    padding: 48, // 6 * 8px (MUI spacing unit)
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <div style={boxStyle}>
      <img alt="Not found" src={emptyBoxImg} />
      <Typography variant="bold1">
        {title || t("common:patient_not_found")}
      </Typography>
    </div>
  );
};

export default EmptyBox;
